<!-- Modal Ajouter Catégorie -->
<div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content shadow-sm">

        <!-- Header -->
        <div class="modal-header text-white">
            <h5 id="upper">Ajouter une catégorie</h5>

            <!-- Bouton Close aligné correctement -->
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>

        <!-- Body -->
        <div class="modal-body">

            <form>

                <div class="mb-3">
                    <label class="form-label fw-bold">Type </label>
                    <select [(ngModel)]="item.type" class="form-select" name="tye" id="type">
                        <option value="marketplace">Marketplace</option>
                        <option value="location">Location</option>

                    </select>


                </div>
                <!-- Nom -->
                <div class="mb-3">
                    <label class="form-label fw-bold">Code </label>
                    <input [(ngModel)]="item.code_categorie" type="text" name="code_categorie" id="categorie"
                        class="form-control" placeholder="" />


                </div>
                <!-- Nom -->

                <div class="mb-3">
                    <label class="form-label fw-bold">Nom de la catégorie</label>
                    <input [(ngModel)]="item.nom" type="text" name="nom" class="form-control"
                        placeholder="Ex : Vêtements" />
                </div>

                <!-- Description -->
                <div class="mb-3">
                    <label class="form-label fw-bold">Description</label>
                    <textarea [(ngModel)]="item.description" name="description" class="form-control" rows="4"
                        placeholder="Décrivez la catégorie..."></textarea>
                </div>
                <!-- Boutons -->
                <div class="d-flex justify-content-end">
                    <a title="Cliquez ici pour annuler " href="javascript: void(0);" (click)="close()"
                        class="btn btn-secondary me-3"
                        style="color: white; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                        Annuler &nbsp;<i class="pi pi-times" style="font-size: 1rem"></i>
                    </a>
                    <a (click)="addCategorie()" title="Cliquez ici pour enregistrer " href="javascript: void(0);"
                        class="btn"
                        style="color: white; background-color: #578D63; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                        Enregistrer &nbsp;<i class="pi pi-save" style="font-size: 1rem"></i>
                    </a>
                </div>

            </form>

        </div>

    </div>
</div>